import { Component, ElementRef, HostAttributeToken, inject, input, ChangeDetectionStrategy } from "@angular/core";

let nextUniqueId = 0;

@Component({
    selector: "vds-error",
    template: "<ng-content />",
    styleUrls: ["./error.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        "[id]": "id()"
    }
})
export class VdsErrorComponent {
    private readonly elementRef = inject(ElementRef);
    ariaLive = inject(new HostAttributeToken("aria-live"), { optional: true });

    id = input<string>(`vds-error-${nextUniqueId++}`);

    constructor() {
        if (!this.ariaLive) {
            // If no aria-live value is set add 'polite' as a default. This is preferred over setting
            // role='alert' so that screen readers do not interrupt the current task to read this aloud.
            this.elementRef.nativeElement.setAttribute("aria-live", "polite");
        }
    }
}
